import React from 'react';
import { ArrowDownCircle, ArrowUpCircle } from 'react-bootstrap-icons';

const CollapsibleSection = ({ sectionName, isCollapsed, onShowHideClick, children, className = '' }) => {
  return (
    <div className={`collapsible-section ${className}`}>
      {/* Section Content */}
      {!isCollapsed && <div className="collapsible-content">{children}</div>}

      {/* Section Footer */}
      <h6 className="hover-underline midFont text-primary my-2 text-right" onClick={onShowHideClick}>
        {isCollapsed ? (
          <>
            Show {sectionName || 'Fields'} <ArrowDownCircle size={13} />
          </>
        ) : (
          <>
            Hide {sectionName || 'Fields'} <ArrowUpCircle size={13} />
          </>
        )}
      </h6>
    </div>
  );
};

export default CollapsibleSection;
